import { render, staticRenderFns } from "./RelationShipFilter.vue?vue&type=template&id=ddb542d2&"
import script from "./RelationShipFilter.vue?vue&type=script&lang=js&"
export * from "./RelationShipFilter.vue?vue&type=script&lang=js&"
import style0 from "./RelationShipFilter.vue?vue&type=style&index=0&id=ddb542d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports